import './ProjectListEmpty.scss';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'src/modules/common/components/Button';
import { PlusIcon } from 'src/modules/common/icons/PlusIcon';
import { UploadIcon } from 'src/modules/common/icons/UploadIcon';

type Props = {
  readonly onCreate: () => void;
  readonly onImport: () => void;
};

export const ProjectListEmpty = ({ onCreate, onImport }: Props): React.ReactElement => {
  const intl = useIntl();

  return (
    <div className="bp-project-list-empty">
      <div className="bp-project-list-empty__container">
        <div className="bp-project-list-empty__content">
          <img
            src="/images/projects/emptyList.svg"
            width={420}
            alt={intl.formatMessage({ id: 'projectList/empty/image' })}
          />

          <h3 className="bp-project-list-empty__title">
            <FormattedMessage id="projectList/empty/title"/>
          </h3>
        </div>

        <div className="bp-project-list-empty__actions">
          <Button
            className="bp-project-list-empty__button"
            onClick={onCreate}
            size="lg"
          >
            <FormattedMessage id="projectList/empty/newProject"/>

            <div className="bp-project-list-empty__button-icon">
              <PlusIcon/>
            </div>
          </Button>

          <Button
            kind="ghost"
            className="bp-project-list-empty__button"
            onClick={onImport}
            size="lg"
          >
            <FormattedMessage id="projectList/empty/importProjects"/>

            <div className="bp-project-list-empty__button-icon">
              <UploadIcon/>
            </div>
          </Button>
        </div>
      </div>
    </div>
  );
};
